import { AgRendererComponent } from 'ag-grid-angular';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'cv-cxone-truncate-text-cell-renderer',
  templateUrl: './cxone-truncate-text-cell-renderer.component.html',
  styleUrls: ['./cxone-truncate-text-cell-renderer.component.scss']
})


export class CxoneTruncateTextCellRendererComponent implements AgRendererComponent {

    params: any;
    value: string;
    searchFilter: string;
    minSearchLength = 1;
    id: string;

    agInit(params: any) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
        this.id = this.params.node.rowIndex + this.params.column.colId;
    }

    refresh(params: any) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
        this.id = this.params.node.rowIndex + this.params.column.colId;
        return true;
    }

    public hidePopover() {
        if (this.params.hidePopover){
            return true;
        }
        //check if text overflows
        if (this.id != "") {
            var el = document.getElementById(this.id);
            if (el.scrollWidth <= el.offsetWidth) {
                return true;
            }
        }
        return false;
    }

    public getPopoverPosition() {
        let first = this.params.api.getFirstDisplayedRow() > 0 ? this.params.api.getFirstDisplayedRow() + 10 : 0; //remove buffered rows https://ag-grid.com/javascript-data-grid/dom-virtualisation/
        let last = this.params.api.getLastDisplayedRow() - 10;
        let row = this.params.node.rowIndex;

        if(Math.abs(row - first) < Math.abs(row - last)) {
            return "bottom-left";
        } else {
            return "top-left";
        }
    }
}
